import { createFileRoute } from "@tanstack/react-router";

import { staffSearchParamsSchema } from "@/domain/staff";
import { StaffScreen } from "@/interactors/StaffScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/staff/")({
  component: StaffScreen,

  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "read",
      subject: "staff",
    }),
  head: () => headWithCustomTitle("main:staff.title"),
  validateSearch: staffSearchParamsSchema,
});
